/*
 * Frudo: light celebration when the cart unlocks a new reward tier.
 *
 * Watches the rewards bar (.frudo-fship, rendered by
 * snippets/frudo-free-ship-bar.liquid). The cart re-renders that bar on every
 * change, so this script lives on the page and reacts when the bar's
 * data-fship-tier number goes up (0 = nothing, 1 = free delivery, 2 = 5% off,
 * 3 = 10% off).
 *
 * The celebration is CSS only (the .frudo-fship--celebrating class: message pop, icon wiggle,
 * bar glow, all defined in snippets/frudo-free-ship-bar.liquid). No falling fruit, no extra DOM.
 *
 * Also: the cart only ever shows the automatic Buy More Save More tier (same as Fastrr checkout),
 * so any manually applied discount code (e.g. WELCOME10) left on the cart is cleared once.
 *
 * Loaded by snippets/cart-drawer.liquid and sections/main-cart.liquid.
 */
(function () {
  if (window.__frudoFreeShip) return;
  window.__frudoFreeShip = true;

  var wasTier = null; // null until the first look, so a page load never celebrates
  var pending = false; // tier went up, but the bar is not on screen yet (drawer closed)
  var timer = null;

  function celebrate(bar) {
    bar.classList.add('frudo-fship--celebrating');
    window.setTimeout(function () {
      bar.classList.remove('frudo-fship--celebrating');
    }, 2200);
  }

  function check() {
    var bar = document.querySelector('.frudo-fship');

    // Empty cart: no bar. Treat as tier 0 so the next unlock celebrates.
    if (!bar) {
      wasTier = 0;
      pending = false;
      return;
    }

    var tier = parseInt(bar.getAttribute('data-fship-tier'), 10) || 0;
    if (wasTier !== null && tier > wasTier) pending = true;
    if (wasTier !== null && tier < wasTier) pending = false;
    wasTier = tier;

    // Only play once the bar is actually visible (e.g. the drawer has opened).
    if (pending && bar.getClientRects().length > 0) {
      pending = false;
      celebrate(bar);
    }
  }

  // Debounced so a cart re-render that briefly swaps nodes is judged once, after it settles.
  function schedule() {
    window.clearTimeout(timer);
    timer = window.setTimeout(check, 200);
  }

  // Clear any discount code (e.g. WELCOME10) left on the cart, so the cart total matches checkout.
  function clearLeftoverCodes() {
    try {
      var last = parseInt(sessionStorage.getItem('frudoCodeCleared') || '0', 10);
      if (Date.now() - last < 15000) return; // never loop
    } catch (e) {}

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var has = (cart.cart_level_discount_applications || []).some(function (a) {
          return a.type === 'discount_code';
        });
        if (!has) {
          (cart.items || []).forEach(function (item) {
            (item.discount_allocations || []).forEach(function (al) {
              if (al.discount_application && al.discount_application.type === 'discount_code') has = true;
            });
          });
        }
        if (!has) return;
        try {
          sessionStorage.setItem('frudoCodeCleared', String(Date.now()));
        } catch (e) {}
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ discount: '' }),
        }).then(function () {
          window.location.reload();
        });
      })
      .catch(function () {});
  }

  function init() {
    check();
    clearLeftoverCodes();
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-fship-tier', 'open'],
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();